import { IUser } from 'common/src/types/interfaces';

import useAuth from 'portal/src/auth/useAuth';
import UserForm from 'portal/src/components/systemAdministration/Form/User/UserForm';
import { FormComponentType } from 'portal/src/layouts/base/FormComponentType';

const AdministrationUserForm: FormComponentType = ({
  entity,
  handleBackAction,
}: {
  entity?: IUser;
  handleBackAction: () => void;
}) => {
  const { getUser } = useAuth();
  const { organizationId } = getUser();

  return (
    <UserForm
      entity={entity}
      handleBackAction={handleBackAction}
      organizationId={organizationId}
    />
  );
};

export default AdministrationUserForm;
